import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const SoundOnIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17 14.724'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <path
        d='M3.967,11.76l.291-.486-.135-.081H3.967Zm0-6.8v.567h.157l.135-.081Zm5.667-3.4H10.2a.567.567,0,0,0-.858-.486Zm0,13.591-.291.486a.567.567,0,0,0,.858-.486ZM15.7,4.564l-.4-.4-.8.8.4.4Zm-.8,6.8-.4.4.8.8.4-.4ZM3.967,11.193H1.7v1.133H3.967Zm-2.267,0a.566.566,0,0,1-.567-.566H0a1.7,1.7,0,0,0,1.7,1.7Zm-.567-.566V6.1H0v4.53Zm0-4.53A.566.566,0,0,1,1.7,5.531V4.4A1.7,1.7,0,0,0,0,6.1ZM1.7,5.531H3.967V4.4H1.7ZM4.258,5.45l5.667-3.4-.583-.972-5.667,3.4ZM9.067,1.567V15.158H10.2V1.567Zm.858,13.105-5.667-3.4-.583.972,5.667,3.4ZM15.3,4.964l-.4.4h0l0,0,.023.025c.022.025.057.067.1.126a3.611,3.611,0,0,1,.336.55,5.086,5.086,0,0,1,.507,2.295H17a6.217,6.217,0,0,0-.627-2.8,4.757,4.757,0,0,0-.443-.724c-.062-.083-.115-.147-.155-.192l-.049-.054-.016-.017L15.7,4.568l0,0h0Zm.567,3.4a5.086,5.086,0,0,1-.507,2.295,3.609,3.609,0,0,1-.336.55c-.044.059-.079.1-.1.126l-.023.025,0,0h0l.4.4.4.4h0l0,0,.006-.006.016-.017.049-.054c.04-.045.093-.11.155-.192a4.764,4.764,0,0,0,.443-.724A6.216,6.216,0,0,0,17,8.362Z'
        transform='translate(0 -1)'
        fill={color || '#FFF'}
      />
    </svg>
  )
}

export default SoundOnIcon
